import { ObservableStore } from '@codewithdan/observable-store';
import { filter } from 'rxjs/operators';
import { defaultSwatch } from '../../data/materials';
import templates from '../../data/templates';
import { Part, Store, Swatch, TemplateKey } from '../types';
import { Editor, Kites } from './Store';

export class Draft extends ObservableStore<Store> {
    stateChanged = this.stateChanged.pipe(filter((state) => !!state));

    constructor() {
        super({
            // logStateChanges: true,
            // stateSliceSelector: state => state.draft,
        });
    }

    public init(kite: Store['draft']) {
        this.setState(
            {
                draft: {
                    ...kite,
                },
            },
            'init_draft'
        );
    }

    changeName(name: string, id: string) {
        this.setState(
            ({ draft }) => ({
                draft: {
                    ...{ draft }.draft,
                    name,
                },
            }),
            'change_name'
        );
        Kites.saveKite(id);
    }

    changeNotes(notes: string, id: string) {
        this.setState(
            ({ draft }) => ({
                draft: {
                    ...draft,
                    meta: {
                        ...draft.meta,
                        notes,
                    },
                },
            }),
            'change_name'
        );
        Kites.saveKite(id);
    }

    changeTemplate(template: TemplateKey) {
        this.setState({
            draft: {
                ...this.getState().draft,
                svg: templates[template].svg,
                parts: [],
                template,
            },
        });
        Editor.isSaved(false);
    }

    setVariation(variation: string) {
        const currentDraft = this.getState().draft;
        if (variation === currentDraft.variation) return;
        this.setState({
            draft: {
                ...currentDraft,
                variation,
            },
        });
        Editor.isSaved(false);
    }

    setParts(parts: Part[]) {
        this.setState({
            draft: {
                ...this.getState().draft,
                parts,
            },
        });
    }

    updatePart(part: Part) {
        const nextParts = this.getState(true).draft.parts;
        const updateIndex = nextParts.findIndex((item) => item.id === part.id);
        nextParts[updateIndex] = part;

        this.setState({
            draft: {
                ...this.getState().draft,
                parts: nextParts,
            },
        });
        Editor.isSaved(false);
    }

    changePartSwatch(part: Part, swatch: Swatch) {
        const nextParts = this.getState(true).draft.parts;
        nextParts.forEach((nextPart) => {
            if (nextPart.id === part.id) {
                nextPart.swatch = swatch || defaultSwatch;
            }
        });

        this.setState({
            draft: {
                ...this.getState().draft,
                parts: nextParts,
            },
        });
    }

    get() {
        return this.getState().draft;
    }
}

export default new Draft();
